import { MaskedInput2 } from 'components'
import { UserContext } from 'context/userContext'
import { numberToMoney } from 'helper/utils'
import { useContext, useCallback } from 'react'
import { Column } from './style'

interface IProps {
  setArr?: any
  arr?: any
}

const Distribution = (props: IProps) => {
  const { data } = useContext(UserContext)
  const { arr, setArr } = props

  const handleChange = useCallback(
    (index: number, name: string, value: any) => {
      const updatedArray = [...arr]
      updatedArray[index] = { ...updatedArray[index], [name]: value }

      if (updatedArray[index].unitMeters) {
        updatedArray[index].unitValue =
          Number(data?.meterValue) * updatedArray[index].unitMeters
        updatedArray[index].unitSupply =
          (updatedArray[index].unitMeters / Number(data?.meters)) *
          Number(data?.maxSupply)
        updatedArray[index].availableSupply = Number(
          updatedArray[index].unitSupply
        )
        if (
          updatedArray[index].soldSupply &&
          updatedArray[index].soldSupply !== 0
        ) {
          updatedArray[index].availableSupply =
            Number(updatedArray[index].unitSupply) -
            Number(updatedArray[index].soldSupply)
        }
      }

      // if (
      //   updatedArray[index].unitMeters &&
      //   (updatedArray[index].soldSupply || updatedArray[index].soldSupply === 0)
      // ) {
      //   updatedArray[index].availableSupply =
      //     Number(updatedArray[index].unitSupply) -
      //     Number(updatedArray[index].soldSupply)
      // }
      setArr(updatedArray)
    },
    [arr]
  )

  return (
    <Column>
      {console.log(arr)}
      {arr.map((item: any, index: number) => {
        return (
          <div key={`${index}_row-distribution`}>
            <div className="new-token-container">
              <MaskedInput2
                large
                maxLength={64}
                dataTestId={`${index}-unitName-input`}
                type="text"
                handleChange={(e: any) => {
                  handleChange(index, 'unitName', e.target.value)
                }}
                placeholder="Unidade"
                name={`[${index}].unitName`}
                defaultValue={item?.unitName}
                uniqKey={`unitName-${index}`} // Unique key
              />
              <MaskedInput2
                large
                dataTestId={`${index}-unitMeters-input`}
                type="number"
                handleChange={(e: any) => {
                  handleChange(index, 'unitMeters', Number(e))
                }}
                placeholder="Quantidade de M² da unidade"
                name={`[${index}].unitMeters`}
                defaultValue={item?.unitMeters}
                uniqKey={`unitMeters-${index}`} // Unique key
              />
              <MaskedInput2
                large
                dataTestId={`${index}-soldSupply-input`}
                type="number"
                handleChange={(e: any) => {
                  handleChange(index, 'soldSupply', Number(e))
                }}
                placeholder="Quantidade de cotas vendidas"
                name={`[${index}].soldSupply`}
                defaultValue={item?.soldSupply}
                uniqKey={`soldSupply-${index}`} // Unique key
              />
              <MaskedInput2
                disabled
                large
                dataTestId={`${index}-unitSupply-input`}
                type="text"
                handleChange={(e: any) => {
                  console.log(e)
                }}
                placeholder="Quantidade de cotas da unidade"
                name={`[${index}].unitSupply`}
                defaultValue={
                  Number.isNaN(item?.unitSupply) || !item?.unitSupply
                    ? null
                    : item?.unitSupply
                }
                uniqKey={`unitSupply-${index}`} // Unique key
              />
              <MaskedInput2
                disabled
                large
                dataTestId={`${index}-unitValue-input`}
                type="text"
                handleChange={(e: any) => {
                  console.log(e)
                }}
                placeholder="Preço da unidade"
                name={`[${index}].unitValue`}
                defaultValue={
                  Number.isNaN(item?.unitValue) || !item?.unitValue
                    ? null
                    : `R$ ${numberToMoney(item?.unitValue)}`
                }
                uniqKey={`unitValue-${index}`} // Unique key
              />
              <MaskedInput2
                disabled
                large
                dataTestId={`${index}-availableSupply-input`}
                type="text"
                handleChange={(e: any) => {
                  console.log(e)
                }}
                placeholder="Quantidade de cotas disponíveis"
                name={`[${index}].availableSupply`}
                defaultValue={
                  Number.isNaN(item?.availableSupply) || !item?.availableSupply
                    ? null
                    : item?.availableSupply
                }
                uniqKey={`availableSupply-${index}`} // Unique key
              />
            </div>
            <div className="grey-division-line" />
          </div>
        )
      })}
    </Column>
  )
}

export default Distribution
